<template>
    <div class="loader">
        <div class="loader-circle"></div>
        <p v-if="loadingText" class="loader-text">{{ loadingText }}</p>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: [
            "loadingText"
        ]
    }
</script>

<style lang="scss" scoped>
    @import "../scss/variables";

    .loader {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .loader-circle {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: solid 2px transparent;
            border-bottom-color: var(--text-color);
            animation: loader infinite 1s;
            display: block;
        }

        .loader-text {
            margin-left: 20px;
        }

        &.color {
            .loader-circle {
                border-bottom-color: var(--accent-color);
            }
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
